module.exports = __webpack_public_path__ + "img/BlendBuff-Mgc.56273367.png";